// extracted by mini-css-extract-plugin
module.exports = {"typeaheadResult":"TypeaheadOption__typeaheadResult___1dQ9t"};